import Swiper from "swiper";
import $ from "jquery";

window.$ = $;
$(document).ready(() => {
	let carouselBlock = $(".swiper-container.sc-carousel");

	if(carouselBlock.length) {

		let carousel = new Swiper('.swiper-container.sc-carousel', {
			slidesPerView: 1.1,
			initialSlide: 0,
			centerInsufficientSlides: true,
			centeredSlides: true,
			breakpoints: {
				768: {
					initialSlide: 1,
					slidesPerView: 1.5,
					arrows: true
				},
				992: {
					initialSlide: 1,
					slidesPerView: 3,
					arrows: true
				}
			},

			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			}
		});
	}
});
